type AnimatedTextSwitchProps = {
  primaryText: string | JSX.Element | undefined;
  secondaryText: string;
  showSecondary: boolean;
};

function AnimatedTextSwitch({ primaryText, secondaryText, showSecondary }: AnimatedTextSwitchProps) {
  return (
    <div className='relative'>
      <span
        aria-hidden={showSecondary}
        className={`flex items-center justify-center transition-transform duration-300 ${showSecondary ? '-translate-y-8 opacity-0' : 'translate-y-0 opacity-100'}`}
      >
        {primaryText}
      </span>
      <span
        aria-hidden={!showSecondary}
        className={`absolute flex items-center justify-center w-full transition-transform duration-300 ${showSecondary ? 'translate-y-0 top-0 opacity-100' : 'translate-y-8 opacity-0'}`}
        style={{ visibility: showSecondary ? 'visible' : 'hidden' }}
      >
        {secondaryText}
      </span>
    </div>
  );
}

export default AnimatedTextSwitch;
